import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private itemsSubject = new BehaviorSubject<MenuItem[]>([]);
  items$ = this.itemsSubject.asObservable();
  private subcontractorNames = new Map<string, string>();

  home: MenuItem = {
    icon: 'fa-regular fa-house',
  };

  constructor(private router: Router, private route: ActivatedRoute) {
    this.updateFromUrl();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateFromUrl();
      }
    });
  }

  insertItem(item: MenuItem) {
    if (item.id) {
      this.subcontractorNames.set(item.id, item.label?.toUpperCase() || '');
    }
    this.updateFromUrl();
  }

  removeItemsAfter(index: number) {
    const newItems = this.itemsSubject.getValue().slice(0, index + 1);
    this.itemsSubject.next(newItems);
  }

  getHomeItem() {
    return this.home;
  }

  private updateFromUrl() {
    const url = this.router.url;
    const breadcrumbs = this.getBreadcrumbsFromUrl(url);
    this.itemsSubject.next(breadcrumbs);
  }

  private getBreadcrumbsFromUrl(url: string): MenuItem[] {
    if (url.includes('/pages/subcontractor')) {
      return [
        {
          label: 'Registro',
          routerLink: '/pages/subcontractor',
        },
      ];
    }

    if (url.includes('/pages/detail/')) {
      const match = url.split('/');
      const id = match.length > 4 ? match[4] : null;
      const subcontractorName = id ? this.subcontractorNames.get(id) : null;

      return [
        {
          label: 'Registro',
          routerLink: '/pages/subcontractor',
        },
        {
          label: subcontractorName || '',
          routerLink: url,
        },
      ];
    }

    return [];
  }
}
